import formatFileSize from './utils'

const messages = {
  _default: () => `waarde is ongeldig.`,
  after: (field, [target, inclusion]) =>
    `moet na ${
      inclusion ? 'of gelijk zijn aan ' : ''
    }${target}.`,
  alpha_dash: () =>
  `veld mag letters en cijfers bevatten evenals min-tekens en onderstrepingstekens.`,
  alpha_num: () =>  `veld mag enkel letters en cijfers bevatten.`,
  alpha_spaces: () => `veld mag enkel letters uit het alfabet en spaties bevatten.`,
  alpha: () =>  `veld mag enkel letters uit het alfabet bevatten.`,
  before: (field, [target, inclusion]) =>
    `moet voor ${
      inclusion ? 'of gelijk zijn aan ' : ''
    }${target}.`,
  between: (field, [min, max]) =>
    `veld moet tussen ${min} en ${max} liggen.`,
  confirmed: () => `bevestiging komt niet overeen.`,
  credit_card: () => `veld is ongeldig.`,
  date_between: (field, [min, max]) =>
    `moet tussen ${min} en ${max} liggen.`,
  date_format: (field, [format]) =>
   `moet de volgende indeling hebben:  ${format}.`,
  decimal: (field, [decimals = '*'] = []) =>
    `veld moet uit cijfers bestaan en mag  ${
      decimals === '*' ? '' : decimals
    }  decimaal punten bevatten.`,
  digits: (field, [length]) =>
  `veld moet uit cijfers bestaan en exact ${length} cijfers bevatten.`,
  dimensions: (field, [width, height]) =>
  `veld moet ${width} x ${height} pixels bevatten.`,
  email: () =>  `veld moet een geldig e-mailadresbevatten.`,
  ext: () =>  `veld moet een geldig bestand bevatten.`,
  image: () =>  `veld moet een afbeelding bevatten.`,
  in: () =>  `veld moet een geldige waarde bevatten.`,
  ip: () =>  `veld moet een geldig IP-adres bevatten.`,
  max: (field, [length]) =>
  `veld mag niet groter zijn dan ${length} tekens.`,
  max_value: (field, [max]) =>  `veld moet ${max} zijn of minder.`,
  mimes: () =>  `veld moet een geldig bestandstype bevatten`,
  min: (field, [length]) =>  `veld moet ten minste ${length} tekens bevatten.`,
  min_value: (field, [min]) => `veld moet ${min} zijn of meer.`,
  not_in: () =>  `veld moet een geldige waarde bevatten.`,
  numeric: () => `veld mag alleen cijfers bevatten.`,
  regex: () =>  `veld formaat is ongeldig.`,
  required: () =>  `veld is verplicht.`,
  size: (field, [size]) =>
  `grootte moet minder dan ${formatFileSize(size)} zijn.`,
  url: () =>  `veld is geen geldige URL.`,
  fullName: () => 'is niet geldig (naam, voornaam en max 120 tekens)',
  emailInput: () => 'veld moet een geldig e-mailadresbevatten.',
  fullNamePerCountry: () => 'is niet geldig (naam, voornaam en max 18 tekens)',
  invalidCharPerCountry: () => 'is not valid (contains invalid characters)',
  orderNumberPerCountry: () => `is too long`,
  blackListZipCodePerCountry: () => 'code is not allowed!'
}

const locale = {
  name: 'nl',
  messages,
  attributes: {}
}

export default locale



// WEBPACK FOOTER //
// ./client/translations/vee-validate/nl.js